export default __webpack_public_path__ + "static/media/welcomeBanner.05bc257a.png";